import {
  CreateOnboardingInfoDto,
  GetOnboardingInfoType,
} from "@intelligems/ig-types/dtos/onboarding-info";
import { useMutation, useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const getOnboardingInfo = async () => {
  const resp = await api.get<GetOnboardingInfoType>(
    `/v2/organizations/onboarding-info`
  );
  return resp.data;
};

export const useGetOnboardingInfo = () => {
  return useQuery<GetOnboardingInfoType, Error>({
    queryKey: ["get-onboarding-info"],
    queryFn: async () => getOnboardingInfo(),
  });
};
